<script>
  import Icon from '$lib/components/Icon.svelte';
  import { getFullDateAndTime } from '$lib/utils/date';
  let { status_message, time, metadata, participant, roomName, isPatient } =
    $props();
  let isMetadataExpanded = $state(false);
  let isParticipantExpanded = $state(false);

  function formatJSON(data) {
    try {
      return JSON.stringify(JSON.parse(data), null, 2);
    } catch {
      return data;
    }
  }

  const MESSAGE_TEXT = {
    // Meeting Lifecycle
    ROOM_CREATED: 'Mötet skapades',
    MEETING_STARTED: 'Mötet startades',
    MEETING_JOINED: 'Mötet anslöts',
    MEETING_JOIN_FAILED: 'Kunde inte ansluta till mötet',
    CLIENT_WAITING: 'Patienten väntar på att mötet ska starta',
    LEAVE_CALL_ERROR: 'Fel vid nedkoppling av mötet',

    // Patient Events
    PATIENT_CLICK_START_CALL_ON_BANNER:
      'Patienten klickade på starta samtalet på banneren',
    PATIENT_CLICK_START_MEETING_IN_LOBBY:
      'Patienten klickade på starta mötet från lobbyn',
    PATIENT_JOINING_MEETING: 'Patienten ansluter till mötet',
    PATIENT_JOINED_MEETING: 'Patienten anslöt till mötet',
    PATIENT_JOIN_MEETING_ERROR: 'Patienten kunde inte ansluta till mötet',
    PATIENT_LEFT_MEETING: 'Patienten lämnade mötet',
    PATIENT_PARTICIPANT_UPDATED: 'Patientens video/ljud uppdaterades',

    // Nurse Events
    NURSE_JOINED_MEETING: 'Sjuksköterskan anslöt till mötet',
    NURSE_LEFT_MEETING: 'Sjuksköterskan lämnade mötet',
    NURSE_PARTICIPANT_UPDATED: 'Sjuksköterskans video/ljud uppdaterades',

    // Camera & Microphone
    PATIENT_CAMERA_AND_MIC_UPDATED:
      'Patientens kamera och mikrofon uppdaterades',
    PATIENT_CAMERA_ERROR: 'Fel med patientens kamera',
    PATIENT_CAMERA_OR_MIC_ERROR: 'Fel med patientens kamera eller mikrofon',
    PATIENT_START_CAMERA_ERROR: 'Patienten kunde inte starta kameran',
    CAMERA_ERROR: 'Kamerafel',

    // Device & Input Settings
    INPUT_SETTINGS_UPDATED: 'Inställningar för input uppdaterades',
    AVAILABLE_DEVICES_UPDATED: 'Tillgängliga enheter uppdaterades',

    // Network & Connection
    NETWORK_QUALITY_CHANGE: 'Nätverkskvaliteten ändrades',
    NETWORK_CONNECTION: 'Nätverksanslutning ändrades',
    NETWORK_INTERRUPTED: 'Nätverksanslutning avbröts',
    NETWORK_RESTORED: 'Nätverksanslutning återställd',
    PATIENT_TRIED_TO_RECONNECT: 'Patienten försökte återansluta',

    // Media Tracks
    TRACK_STARTED: 'Media track startades',
    TRACK_STOPPED: 'Media track stoppades',

    // Transcription
    TRANSCRIPTION_STARTED: 'Transkribering startades',
    TRANSCRIPTION_STOPPED: 'Transkribering stoppades',
    TRANSCRIPTION_INIT_FAILED: 'Transkribering kunde inte initieras',
    TRANSCRIPTION_START_FAILED: 'Transkribering kunde inte startas',
    TRANSCRIPTION_STOP_FAILED: 'Transkribering kunde inte stoppas',

    // Errors & Diagnostics
    ERROR: 'Ett fel uppstod',
    NONFATAL_ERROR: 'Icke-kritiskt fel uppstod',
    DIAGNOSTIC_COLLECTED: 'Diagnostisk data samlades in',
  };
</script>

<div class="flex flex-row items-start gap-4 py-2">
  <div class="relative flex flex-col items-center">
    <div class="h-full w-px bg-gray-200"></div>
    <div class="absolute top-2 -ml-0.5 h-2 w-2 rounded-full bg-gray-300"></div>
  </div>
  <div class="w-full">
    <div class="flex flex-row justify-between gap-2">
      <div class="flex flex-col">
        <div class="mb-1 flex flex-row items-center gap-2 font-medium">
          <div>{MESSAGE_TEXT[status_message] || status_message}</div>
        </div>
        <div class="flex flex-row gap-2">
          <div class="text-sm text-gray-500">{getFullDateAndTime(time)}</div>
        </div>
      </div>
      <div>
        {#if isPatient}
          <Icon icon="user" />
        {:else}
          <Icon icon="hospital" />
        {/if}
      </div>
    </div>

    {#if roomName}
      <div class="mt-2 text-sm text-gray-500">
        <span class="font-medium">Room:</span>
        <a
          href="https://dashboard.daily.co/rooms/{roomName}"
          target="_blank"
          rel="noopener noreferrer"
          class="text-blue-500 hover:underline"
        >
          {roomName}
        </a>
      </div>
    {/if}

    {#if metadata}
      <div class="mt-2 text-sm text-gray-500">
        <button
          class="flex items-center gap-1 hover:text-gray-700"
          onclick={() => (isMetadataExpanded = !isMetadataExpanded)}
        >
          <span
            class="transform transition-transform {isMetadataExpanded
              ? 'rotate-90'
              : ''}"
          >
            ▶
          </span>
          Metadata
        </button>
        {#if isMetadataExpanded}
          <pre
            class="mt-2 whitespace-pre-wrap rounded bg-gray-50 p-2 font-mono text-xs">{formatJSON(
              metadata,
            )}</pre>
        {/if}
      </div>
    {/if}

    {#if participant}
      <div class="mt-2 text-sm text-gray-500">
        <button
          class="flex items-center gap-1 hover:text-gray-700"
          onclick={() => (isParticipantExpanded = !isParticipantExpanded)}
        >
          <span
            class="transform transition-transform {isParticipantExpanded
              ? 'rotate-90'
              : ''}"
          >
            ▶
          </span>
          Participant
        </button>
        {#if isParticipantExpanded}
          <pre
            class="mt-2 whitespace-pre-wrap rounded bg-gray-50 p-2 font-mono text-xs">{formatJSON(
              participant,
            )}</pre>
        {/if}
      </div>
    {/if}
  </div>
</div>
